import axios from 'axios';

import configureSmooch from 'configuration/configureProvider';
import generateSessionFromConversation from 'adapters/converters/fromSmoochConversationToSession';

export default class SmoochChatGateway {
  constructor(smooch) {
    this.smooch = smooch;
  }

  getSession() {
    const conversation = this.smooch.getConversation();
    return conversation ? generateSessionFromConversation(conversation) : null;
  }

  getSessionId() {
    const conversation = this.smooch.getConversation();
    return conversation ? conversation._id : null;
  }

  async configureProvider(providerId) {
    // we should handle the error here
    await configureSmooch(providerId, this.smooch);
  }

  async auth({ name, email, orgDomain, loginDomain, appId, providerId }) {
    return await axios.post(`${orgDomain}/api/smooch/v1/authenticate`, { name, email, loginDomain, appId, providerId });
  }

  login({ userId, token }, gladlyCustomerId, appId) {
    return this.smooch.login(userId, token).then(() => {
      // Adding appId and gladlyCustomerId to the appUser, this will embedded the values
      // on all webhook event so that so that the server can tell who the user is and
      // what appId (endpoint address) is used.
      const properties = { appId };
      if (gladlyCustomerId) {
        properties['gladlyCustomerId'] = gladlyCustomerId;
      }
      this.smooch.updateUser({ properties });
    }); // returns a promise
  }

  async reconnect() {
    return await this.smooch.reconnect();
  }

  registerConnectionCallbacks({ handleConnected, handleDisconnected }) {
    this.smooch.on('connected', handleConnected);
    this.smooch.on('disconnected', handleDisconnected);
  }
}
